import {
  AUTH_SET_CURRENT_USER_DATA,
  AUTH_SET_LOADING,
  AUTH_SET_LOGIN_STATUS,
} from "../actions/auth.actions";
import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  loggedIn: true,
  loading: true,
  currentUser: { email: "" }
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_SET_LOGIN_STATUS:
      return {
        ...state,
        loggedIn: action.data,
      };
    case AUTH_SET_LOADING:
      return {
        ...state,
        loading: action.data,
      };
    case AUTH_SET_CURRENT_USER_DATA:
      return {
        ...state,
        currentUser: action.data,
      };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
